import { configureStore } from "@reduxjs/toolkit";
import themeReducer from "./theme/themeSlice";
import divisionReducer from "./division/divisionSlice";
import toastReducer from "./toast/toastSlice";
import authReducer from "./auth/authSlice";
import adminSettingsReducer from "./adminSettings/adminSettingsSlice";

export default configureStore({
  reducer: {
    theme: themeReducer,
    division: divisionReducer,
    adminSettings: adminSettingsReducer,
    toast: toastReducer,
    auth: authReducer,
  },
});
